import React from 'react'
import { Trans } from '@lingui/macro'
import { bool, func, string } from 'prop-types'

import Form from 'views/components/atoms/Form'
import ButtonTransparent from 'views/components/molecules/ButtonTransparent'
import Icon from 'views/components/atoms/Icon'
import InputTextWithFloatingLabel from 'views/components/molecules/InputTextWithFloatingLabel'

import SearchBoxList from 'views/components/organisms/SearchBox/SearchBoxList'
import SearchHistory from 'views/components/organisms/SearchBox/SearchHistory'

import './../SearchBox.scss'
import './SearchBoxMobile.scss'

const SearchBoxMobile = ({
  query,
  inputId,
  displayResults,
  products,
  displayHistory,
  searchHistory,
  handleClear,
  handleShowAll,
  handleSubmit,
  handleClearHistory,
  handleItemClick,
  handleQueryUpdate,
  handleInputUpdate,
  formAction,
  open
}) => {
  const inputProps = {
    inputType: 'search',
    name: 'query',
    inputId,
    disableAutoCompleteAndFriends: true,
    onChange: handleInputUpdate,
    onClear: handleClear,
    value: query,
    rounded: false,
    inputClassname: 'o-SearchBox__input',
    'data-clientside-hook': 'search__input--mobile'
  }

  const searchBoxListProps = {
    mobile: true,
    query,
    displayResults,
    products,
    handleShowAll,
    handleItemClick,
    formAction
  }

  return (
    <div
      role="dialog"
      className="m-Modal__dialog m-Modal__dialog--fullScreen o-SearchBox u-overflow"
      open={open ? true : undefined}
    >
      <div className="l-flex o-Searchbox__header">
        <div>
          <ButtonTransparent
            href="#"
            name="smallheader-hide-search-button"
            data-a11y-dialog-hide
          >
            <Icon icon="arrowLeft" size="default" />
            <span className="a-visuallyhidden">
              <Trans id="general.link.label.back" />
            </span>
          </ButtonTransparent>
        </div>
        <Form
          className="l-flex__primary"
          name="search-box"
          method="get"
          data-clientside-hook="chargeUrlSearchParams"
          action={formAction}
          onSubmit={handleSubmit}
        >
          <InputTextWithFloatingLabel {...inputProps}>
            <Trans id="general.label.placeholder.search" />
          </InputTextWithFloatingLabel>
        </Form>
      </div>
      <SearchBoxList {...searchBoxListProps} />
      {displayHistory && (
        <SearchHistory
          searchHistory={searchHistory}
          handleClearHistory={handleClearHistory}
          handleQueryUpdate={handleQueryUpdate}
        />
      )}
    </div>
  )
}

SearchBoxMobile.propTypes = {
  ...SearchHistory.propTypes,
  ...SearchBoxList.propTypes,
  inputId: string.isRequired,
  formAction: string.isRequired,
  displayHistory: bool,
  handleChange: func,
  handleClear: func,
  open: bool
}

SearchBoxMobile.defaultProps = {
  ...SearchHistory.defaultProps,
  ...SearchBoxList.defaultProps,
  displayHistory: false,
  handleChange: null,
  handleClear: null,
  open: false
}

export default SearchBoxMobile
